angular.module('core').filter('nullableNumber', ['numberFilter',
  function($numberFilter) {
    return function(input, decimalPlaces) {
      if(_.isUndefined(input) || input === null) {
        return 'N/A';
      }
      else {
        return $numberFilter(input, decimalPlaces);
      }
    };
  }
]);
